import { Link, NavLink, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RiHome2Fill } from 'react-icons/ri'
import NavBarDesktopSearchButton from './NavBarDesktopSearchButton'
import NavbarDesktopFutureMineralsMenu from './NavbarDesktopFutureMineralsMenu'

export default function NavbarDesktop() {
  const { lng } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const { t, i18n } = useTranslation()

  // Functions
  const handleOnClickChangeLanguage = (newLng) => {
    if (newLng !== lng) {
      const newUrl = location.pathname.replace(`/${lng}`, `/${newLng}`)
      i18n.changeLanguage(newLng)
      navigate(`${newUrl}?${searchParams.toString()}`)
    }
  }

  return (
    <nav className="hidden bg-light py-2 md:block">
      <div className="app-container px-8 lg:px-0">
        <div className="flex items-center justify-between font-bold">
          <div className="flex items-center gap-8">
            <Link
              className="text-secondary-600"
              title={t('HOME')}
              to={`/${lng}/home`}
            >
              <RiHome2Fill size={32} />
            </Link>
            <ul className="flex items-center gap-1">
              <NavbarDesktopFutureMineralsMenu />
              <li>
                <div className="bg-muted-300 h-6 w-[2px]" />
              </li>
              <li>
                <NavLink
                  className={`whitespace-nowrap px-3 py-1.5`}
                  to={`/${lng}/opportunities`}
                >
                  {t('OPPORTUNITIES')}
                </NavLink>
              </li>
              <li>
                <div className="bg-muted-300 h-6 w-[2px]" />
              </li>
              <li>
                <NavLink
                  className={`whitespace-nowrap px-3 py-1.5`}
                  to={`/${lng}/minerals/alalmnyom-aluminium/prices?CHART=AREA&INTERVAL=MONTH`}
                >
                  {t('MINERALS_PRICES')}
                </NavLink>
              </li>
              <li>
                <div className="bg-muted-300 h-6 w-[2px]" />
              </li>
              <li>
                <Link
                  className={`whitespace-nowrap px-3 py-1.5`}
                  to={`/region/map`}
                  // to={`/region/map?lang=${lng}`}
                  target="_blank"
                >
                  {t('REGION_MAP')}
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex items-center gap-2">
            <button
              className="hover:border-secondary-600 border-muted-300 hover:bg-muted-300 border-2 px-5 py-1.5"
              onClick={() => handleOnClickChangeLanguage(lng === 'en' ? 'ar' : 'en')}
            >
              {lng === 'en' ? 'العربية' : 'English'}
            </button>
            <NavBarDesktopSearchButton />
          </div>
        </div>
      </div>
    </nav>
  )
}
